// export const BASE_URL = 'http://10.120.1.11:9082';
export const BASE_URL = 'https://crypto.mobilelab.vn';
// export const BASE_URL = 'https://dev.api.crypto.mobilelab.vn';
// export const BASE_URL = 'http://localhost:9082';
// export const BASE_URL = 'http://192.168.100.11:9082';
// export const BASE_URL = 'http://localhost:9082';
// export const BASE_URL = 'http://113.190.221.206:9082';
// export const PREFIX_FRONT_URL = "";
export const PREFIX_FRONT_URL = '';
export const API_VERSION = 'v1';
// export const WS_URL = 'ws://localhost:9082';
export const WS_URL = 'wss://crypto.mobilelab.vn';
// export const WS_URL = 'wss://dev.api.crypto.mobilelab.vn';

export default {
  TYPE_ERROR: 'error',
  TYPE_WARNING: 'warning',
  TYPE_SUCCESS: 'success',
  TYPE_INFO: 'info',
  FORM_LAYOUT: {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
    INLINE: 'inline',
  },
  MODAL_CONFIG_PREFIX: '',
  MODAL_DETAIL: 'detail',
  MODAL_EDIT: 'edit',
  MODAL_DEL: 'del',
  MODAL_ADD: 'add',
  MODAL_DOWNLOAD: 'download',
  MODAL_API_GROUP: 'api_group',
  MODAL_CONFIG_DETAIL: 'config_detail',
  MODAL_CONFIG_EDIT: 'config_edit',
  MODAL_CONFIG_CLONE: 'config_clone',
  MODAL_CONFIG_DEL: 'config_del',
  MODAL_CONFIG_ADD: 'config_add',
  MODAL_CONFIG_DOWNLOAD: 'config_download',
  MODAL_API_GROUP_DETAIL: 'api_group_detail',
  MODAL_API_GROUP_EDIT: 'api_group_edit',
  MODAL_API_GROUP_DEL: 'api_group_del',
  MODAL_API_GROUP_ADD: 'api_group_add',
  MODAL_API_GROUP_DOWNLOAD: 'api_group_download',
  DEFAULT_HEADERS: {},
  ORDER_TRADE_TYPE_BUY: 0,
  ORDER_TRADE_TYPE_BUY_STR: 'Buy',
  ORDER_TRADE_TYPE_SELL: 1,
  ORDER_TRADE_TYPE_SELL_STR: 'Sell',

  ORDER_TYPE_LIMIT: 0,
  ORDER_TYPE_MARKET: 1,
  ORDER_TYPE_STOP_LIMIT: 2,
  ORDER_TYPE_STOP_MARKET: 3,
  ORDER_TYPE_LIMIT_STR: 'Limit',
  ORDER_TYPE_MARKET_STR: 'Market',
  ORDER_TYPE_STOP_LIMIT_STR: 'Stop Limit',
  ORDER_TYPE_STOP_MARKET_STR: 'Stop Market',

  WITH_DRAWAL_LIMITS: 1,

  ORDER_STATUS_STOPPING: 0,
  ORDER_STATUS_PENDING: 1,
  ORDER_STATUS_EXECUTED: 2,
  ORDER_STATUS_CANCELED: 3,
  ORDER_STATUS_EXECUTING: 4,
  ORDER_STATUS_REMOVED: 5,
  ORDER_STATUS_STOPPING_STR: 'Stopping',
  ORDER_STATUS_PENDING_STR: 'Pending',
  ORDER_STATUS_EXECUTED_STR: 'Executed',
  ORDER_STATUS_CANCELED_STR: 'Canceled',
  ORDER_STATUS_EXECUTING_STR: 'Executing',
  ORDER_STATUS_REMOVED_STR: 'Removed',

  TRANSACTION_STATUS_SUCCESS: 0,
  TRANSACTION_STATUS_PENDING: 1,
  TRANSACTION_STATUS_SUBMITTED: 2,
  TRANSACTION_STATUS_ERROR: 3,
  TRANSACTION_STATUS_CANCEL: 4,
  TRANSACTION_STATUS_REJECTED: 5,
  TRANSACTION_STATUS_SUCCESS_STR: 'Succeed',
  TRANSACTION_STATUS_PENDING_STR: 'Pending',
  TRANSACTION_STATUS_SUBMITTED_STR: 'Submitted',
  TRANSACTION_STATUS_ERROR_STR: 'Error',
  TRANSACTION_STATUS_CANCEL_STR: 'Cancel',
  TRANSACTION_STATUS_REJECTED_STR: 'Rejected',

  TRANSACTION_TYPE_DEPOSIT: 0,
  TRANSACTION_TYPE_WITHDRAW: 1,
  TRANSACTION_TYPE_DEPOSIT_STR: 'user.deposit_and_withdrawal.deposits',
  TRANSACTION_TYPE_WITHDRAW_STR: 'user.deposit_and_withdrawal.withdrawal',

  DEFAULT_BADGE_COUNT: 9,
  DEFAULT_PAGE_SIZE: 10,
  DEFAULT_PAGE_SIZE_OPEN_ORDER: 25,
  MAX_WIDTH: 1400,

  WS_EVENT_PUBLIC_ORDER_BOOK: 'WS_EVENT_PUBLIC_ORDER_BOOK',
  WS_EVENT_UPDATE_ORDER_TRANSACTION: 'WS_EVENT_UPDATE_ORDER_TRANSACTION',
  WS_EVENT_LAST_PRICE_UPDATED: 'WS_EVENT_LAST_PRICE_UPDATED',
  WS_EVENT_LAST_PRICE: 'WS_EVENT_LAST_PRICE',

  WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_SELL: 'WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_SELL',
  WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_BUY: 'WS_EVENT_PUBLIC_BATCH_ORDER_BOOKS_BUY',
  WS_EVENT_UPDATE_BATCH_ORDER_TRANSACTION: 'WS_EVENT_UPDATE_BATCH_ORDER_TRANSACTION',

  WS_EVENT_AUTH: 'WS_EVENT_AUTH',
  WS_EVENT_ORDER_CREATED: 'WS_EVENT_ORDER_CREATED',
  WS_EVENT_ORDER_CANCELED: 'WS_EVENT_ORDER_CANCELED',
  WS_EVENT_UPDATE_COIN_ACCOUNT: 'WS_EVENT_UPDATE_COIN_ACCOUNT',
  WS_EVENT_OPEN_ORDER: 'WS_EVENT_OPEN_ORDER',
  WS_EVENT_USER_TRANSACTION: 'WS_EVENT_USER_TRANSACTION',

  PREFIX_FRONT_URL: '/v1/cryptotrading',
  routes: {
    USER_INFO: 'user/info',
    USER_WALLET: 'user/wallet',
    USER_COMMISSION_HISTORY: 'user/wallet/commission-history',
    DEPOSIT: 'user/wallet/deposit',
    WITHDRAW: 'user/wallet/withdrawal',
    DEPOSIT_WITHDRAWAL: 'user/wallet/deposit-withdrawal',
    OPEN_ORDER: 'user/wallet/open-order',
    ORDER_HISTORY: 'user/wallet/order-history',
    ORDER_TRANS_HISTORY: 'user/wallet/order-trans-history',
    USER_LOGIN_HISTORY: 'user/wallet/user-login-history',
    BUY_WITH_CARD: 'buy-with-card',
    MARKET: 'market',
    HOME: 'home',
    ROOT: 'root',
    LOGIN: 'login',
    VERIFY: 'verify/email',
    VERIFY_WITHDRAW: 'verify/withdrawal',
    USER_SECURITY: 'user/wallet/security',
    GUIDE: 'guide',
    FAQS: 'faqs',
    FAQS_1: 'faqs',
    FAQS_2: 'faqs/2',
    FAQS_3: 'faqs/3',
    FAQS_4: 'faqs/4',
    FAQS_5: 'faqs/5',
    FAQS_6: 'faqs/6',
    REFERRAL: 'referral',
    NOTIFICATION: 'notification',
    PAGECAMPAIGN: 'campaign',
  },

  style: {
    COMMON_GUTTER: 16,
  },

  DEFAULT_MARGIN: 10,
  DEFAULT_DURATION: 300,
  PRIMARY_COLOR: '#1DA57A',
  COLOR_BUY: '#1DA57A',
  COLOR_SELL: '#df4249',
  ERC_20: 'erc20',
  ETH: 'eth',
  CUSTOM_COIN: 'custom',

  EN: 'en',
  VI: 'vi',
  KO: 'korea',

  DEFAULT_PRECISION: 8,
  PUBKEY_LENGTH: 66,
};
